// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mHkvhPa5L7jxHSyGaaAo{display:flex;flex-grow:1;flex-direction:column}`, "",{"version":3,"sources":["webpack://./src/pages/campaigns/ui/detail/CampaignDetail/ui/Content/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,WAAA,CACA,qBAAA","sourcesContent":[".wrap {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `mHkvhPa5L7jxHSyGaaAo`
};
export default ___CSS_LOADER_EXPORT___;
